export default "__VITE_ASSET__ChRQ_N30__"